<section class="p-4 p-md-5">
    <div class="align-items-center d-flex flex-column h-100">
            <img [src]="imageLogo" alt="404" class="img-fluid mb-5">
        <div class="text-center message" [style.color]="'#FFFFFF'">
           <!-- <span >{{message}}</span> -->
            <span [innerHTML]="message"></span>
        </div>
    </div>
</section>